export default "__VITE_ASSET__B3s0VTcC__"